export default __webpack_public_path__ + "static/media/userActive.b202ff45.svg";